import { Fragment } from 'react';
import cx from 'classnames';

import { CDN_CLRSAVE_URL } from '../../constants/index';
import styles from '../../styles/homePage/card.scss';

interface Props {
  data?: any;
  handleClick?: VoidFunction;
  investClick?: VoidFunction;
  className?: string;
  hideHighlights: boolean;
  hideBenifits: boolean;
  hideSpacer: boolean;
  minHeight: boolean;
}

const Card = ({
  data,
  handleClick,
  investClick,
  className,
  hideBenifits,
  hideHighlights,
  minHeight,
  hideSpacer,
}: Props) => (
  <div
    onClick={handleClick}
    className={cx(styles['plan-card'], className, {
      [styles['min-height']]: !minHeight,
    })}
    style={{ minHeight }}
  >
    <div className={cx(styles['plan-card-header'], 'flex')}>
      <label
        className={cx(
          'font--bold text--lg font--dark-grey',
          styles['card-title']
        )}
      >
        {data.title}
      </label>
      <div className={styles['card-details']}>
        <span
          className={cx('text--xlg font--bold', styles['card-return-value'])}
        >
          {data.planSummary
            ? data.planSummary.returns.return5yr
            : data.rating.returns}
          <span className="text--sm">%</span>
        </span>
        <label
          className={cx(
            'block text--xsm font--normal font--dark-grey text--uppercase font--bold',
            styles['card-return-label']
          )}
        >
          {data.rating.returnLabel}
        </label>
      </div>
    </div>
    <div className={styles['card-content']}>
      {data.duration && !hideHighlights ? (
        <div className={cx(styles['highlights-container'])}>
          <img
            src={`${CDN_CLRSAVE_URL}/clearsave/images/gold_medal.png`}
            className={styles.medal}
          />
          <p
            className={cx('inline-block verticle-align-top', styles.highlights)}
            dangerouslySetInnerHTML={{
              __html: data.duration.content.join('<br/> ') || '',
            }}
          />
        </div>
      ) : null}
      <button
        onClick={investClick}
        className={cx(
          's-btn s-btn--blue text--md btn-shine full-width',
          styles[data.actionButton.color],
          styles['action-button']
        )}
      >
        {data.actionButton.actionButtonLabel}
      </button>
      {!hideSpacer ? <div className={cx(styles.spacer)} /> : null}
      {data.benefits && !hideBenifits && (
        <Fragment>
          <label className={cx('font--lightgrey text--sm text--uppercase')}>
            {data.benefits.benefitsLabel}
          </label>
          <ul className={cx(styles['card-benefits'])}>
            {data.benefits.benefits.map(benefit => (
              <li
                className={cx('text--md font--grey', styles['card-benefit'])}
                key={benefit}
              >
                {benefit}
              </li>
            ))}
          </ul>
        </Fragment>
      )}
      {data.funds && (
        <Fragment>
          <div className="row">
            <div className={cx('large-12 columns')}>
              <label className="font--lightgrey text--sm text--uppercase">
                {data.funds.fundsLabel}
              </label>
              <ul className={styles['funds-list']}>
                {data.funds.funds.map((fund, idx) => (
                  <li
                    className={styles['fund-wrapper']}
                    key={`${fund.title}_${idx}`}
                  >
                    <a>
                      <img
                        src={`${CDN_CLRSAVE_URL}/clearsave/images/${fund.image}`}
                        className={styles['fund-image']}
                        alt={fund.title}
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Fragment>
      )}
    </div>
  </div>
);

export default Card;



// WEBPACK FOOTER //
// ./components/homePage/card.tsx